<template>
    <div class="datepicker-container" v-bind="schema.attributes">
        <multiselect
            v-model="value"
            :placeholder="schema.placeholder || ''"
            :options="schema.values"
            :track-by="!schema.selectOptions || schema.selectOptions.trackBy == undefined ? 'id' : schema.selectOptions.trackBy"
            :label="!schema.selectOptions || schema.selectOptions.label == undefined ? 'nom' : schema.selectOptions.label"
            :show-labels="false"
            tag-placeholder="+"
            v-on="schema.onTag ? { tag: schema.onTag } : {}"
            v-bind="{ ...schema.selectOptions }"
        >
            <template #noOptions>Aucun élément trouvé</template>
        </multiselect>
    </div>
</template>

<script>
    import multiselect from "vue-multiselect";
    import { abstractField } from "vue-form-generator";

    export default {
        mixins: [abstractField],
        components: {
            multiselect
        }
    };
</script>

<style lang="scss">
    .multiselect {
        &__select {
            z-index: 2;
        }

        &__spinner {
            z-index: 1;
            border-radius: 4px;

            &::before,
            &::after {
                border-top-color: $primary;
            }
        }
    }
</style>
